import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=3c609294&"
import script from "./pricing.vue?vue&type=script&lang=js&"
export * from "./pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscriptionGetPackages: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/Subscription/GetPackages.vue').default})
